// https://stackoverflow.com/questions/56570937/styled-components-typescript
export const important = <T extends string>(s: T): T => `${s} !important` as T;
